<template>
  <div v-if="!loading">
    <div class="d-flex align-center">
      <v-img v-if="user.photoPath" :src="user.photoPath" max-height="250" max-width="250" contain></v-img>
      <div class="user-info" style="width:100%">
        <!-- <template>
          <p class="body-1 pb-0 mb-0 font-weight-bold">
            {{ $t("preferredLanguageLabel") }}:
          </p>

          <p class="body-1 pb-0 mb-0 font-weight-bold">
            {{ $t("enterActualPasswordLabel") }}:
          </p>
          <v-text-field v-model="changePasswordForm.actualPassword" type="password" outlined dense></v-text-field>
          <p class="body-1 pb-0 mb-0 font-weight-bold">
            {{ $t("enterPasswordLabel") }}:
          </p>
          <v-text-field type="password" v-model="changePasswordForm.password" :rules="changePasswordRules.password"
            outlined dense></v-text-field>
          <p class="body-1 pb-0 mb-0 font-weight-bold">
            {{ $t("confirmPasswordLabel") }}:
          </p>
          <v-text-field v-model="changePasswordForm.confirmPassword" :rules="changePasswordRules.confirmPassword"
            type="password" outlined dense></v-text-field>
          <div>
            <v-btn  class="primary mr-4" @click="changeLanguage()">{{
              $t("saveDataLabel")
            }}</v-btn>
            <v-btn class="red white--text" @click="editMode = false">{{ $t('cancelLabel') }}</v-btn>
          </div>
        </template> -->
        <v-dialog v-model="changePasswordDialog" max-width="800px">
          <v-card class="pa-10">
            <v-card-title class="justify-center">
              <span class="headline">{{ $t('changePasswordTitleLabel') }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <div style="width:100%">

                  <p class="body-1 pb-0 mb-0 font-weight-bold">
                    {{ $t("enterActualPasswordLabel") }}:
                  </p>
                  <v-text-field v-model="changePasswordForm.actualPassword" type="password" outlined dense>
                  </v-text-field>
                  <p class="body-1 pb-0 mb-0 font-weight-bold">
                    {{ $t("enterPasswordLabel") }}:
                  </p>
                  <v-text-field type="password" v-model="changePasswordForm.password" validate-on-blur
                    :rules="changePasswordRules.password" outlined dense></v-text-field>
                  <p class="body-1 pb-0 mb-0 font-weight-bold">
                    {{ $t("confirmPasswordLabel") }}:
                  </p>
                  <v-text-field v-model="changePasswordForm.confirmPassword"
                    :rules="changePasswordRules.confirmPassword" type="password" outlined dense validate-on-blur>
                  </v-text-field>
                </div>
              </v-container>
            </v-card-text>

            <v-card-actions class="d-flex justify-center align-center">
              <v-btn :disabled="!validated" min-width="150" class="white--text px-10" color="red"
                @click="changePassword()">
                {{ $t("changePasswordLabel") }}
              </v-btn>

              <v-btn min-width="150" class="primary px-2" color="" @click="changePasswordDialog = false">
                {{ $t("cancelLabel") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row >
          <v-col cols="6">
            <p class="body-1 pb-0 mb-0 font-weight-bold">
              {{ $t("fullNameLabel") }}
            </p>
            <p class="body-2">{{ user.fullName }}</p>
            <p class="body-1 pb-0 mb-0 font-weight-bold">
              {{ $t("emailLabel") }}
            </p>
            <p class="body-2">{{ user.email }}</p>
            <p class="body-1 pb-0 mb-0 font-weight-bold">
              {{ $t("personalNumberLabel") }}
            </p>
            <p class="body-2">{{ user.personalNo }}</p>
            <p class="body-1 pb-0 mb-0 font-weight-bold">
              {{ $t("entryDateLabel") }}
            </p>
            <p class="body-2">{{new Date(user.entryDate).toLocaleString()}}</p>
            <p class="body-1 pb-0 mb-0 font-weight-bold">{{$t('userTypeLabel')}}</p>
            <p class="body-2">{{$t(getUserTypeLabel(user.userType))}}</p>
            <div v-if="!isAdmin">
              <p class="body-1 pb-0 mb-0 font-weight-bold">
                {{ $t("activeLabel") }}
              </p>
              <p class="body-2">{{ user.active }}</p>
              <p class="body-1 pb-0 mb-0 font-weight-bold">
                {{ $t("lockedLabel") }}
              </p>
              <p class="body-2">{{ user.locked }}</p>
            </div>
          </v-col>
          <v-col cols="6" align-self="center" justify-center v-if="canEdit">
            <p class="body-1 pb-0 mb-0 font-weight-bold">
              {{ $t("preferredLanguageLabel") }}
            </p>
            <v-select @input="changeLanguage" outlined dense class="body-2" v-model="selectedLanguage"
              :items="languages" item-text="name" return-object></v-select>
            <v-divider class="my-5"/>
            <div class="d-flex">
              <!-- <v-btn class="primary mr-2" @click="editMode = true">{{$t("changePreferredLanguage")}}</v-btn> -->
              <v-btn class="primary mt-5" width="100%" @click="changePasswordDialog = true">{{ $t("changePasswordLabel") }}
              </v-btn>
            </div>
          </v-col>

        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import UserTypes from '../auth/userTypes'
  import store from "@/store";
  import {getUserTypeLabel} from "@/auth/userTypes"

  export default {
    name: "UserProfile",
    data() {
      const defaultPasswordForm = Object.freeze({
        actualPassword: '',
        password: '',
        confirmPassword: '',
      })

      return {
        getUserTypeLabel: getUserTypeLabel,
        changePasswordDialog: false,
        isAdmin: false,
        loading: true,
        changePasswordForm: Object.assign({}, defaultPasswordForm),
        editMode: false,
        user: {},
        selectedLanguage: "",
        selected: "",
        changePasswordRules: {
          password: [
            val => !!val || this.$t('requiredValueLabel')
          ],
          confirmPassword: [
            val => (val || '').length > 0 || this.$t('requiredValueLabel'),
            val => val === this.changePasswordForm.password || this.$t('passwordsMatchLabel')
          ]
        },
        snackbar: {
          show: true,
          message: "",
        }
      };
    },
    props: {
      userId: Number,
    },
    methods: {
      getUser() {
        this.$EventBus.$emit("loading", true);
        var userId = this.$props.userId;
        this.axios
          .get("api/user/getbyid/", {
            params: {
              id: userId ? userId : this.$route.params.affiliateUserId,
            },
          })
          .then((response) => {
            this.$EventBus.$emit("loading", false);
            this.loading = false
            this.user = response.data;
            this.selectedLanguage = this.user.preferedLanguage;
          })
          .catch((error) => {
            this.loading = false
            console.log(error);
          });
      },
      // saveChanges() {
      //   this.changeLanguage()
      //   this.changePassword()
      //   this.editMode = false
      //   const snackbar = {
      //     show: true,
      //     message: "Changes saved!",
      //   };
      //   this.$EventBus.$emit("snackbar", snackbar);
      // },
      changeLanguage() {
        const data = {
          userId: this.userId,
          preferedLanguageId: this.selectedLanguage.isO639,
        };
        this.axios
          .post("api/user/changePreferedLanguage", data)
          .then((response) => {
            this.$store.dispatch("setPreferredLanguage", this.selectedLanguage);
            this.$i18n.locale = this.selectedLanguage.isO639;
            this.getUser();
            this.snackbar.message = this.$t("languageChangedLabel") + " " + this.selectedLanguage.name,
              this.$EventBus.$emit("snackbar", this.snackbar);
          })
          .catch((error) => {
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);
          });
      },
      changePassword() {

        this.axios.post("api/user/changePassword", {
            id: this.userId,
            oldPassword: this.changePasswordForm.actualPassword,
            newPassword: this.changePasswordForm.confirmPassword,
          })
          .then((response) => {
            console.log(response)
            this.snackbar.message = response.data
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.changePasswordDialog = false
            this.resetDialog()
            this.snackbar.message = response.data
            this.$EventBus.$emit("snackbar", this.snackbar);
          }).catch((error) => {
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);

            //   show: true,
            //   message: "Password change failed!",
            // };
            // this.$EventBus.$emit("snackbar", snackbar);
          });
        // [Required]
        // public int ID {
        //   get;
        //   set;
        // }

        // [Required]
        // public string OldPassword {
        //   get;
        //   set;
        // }

        // [Required]
        // public string NewPassword {
        //   get;
        //   set;
      },
      resetDialog() {
        this.changePasswordForm.actualPassword = ''
        this.changePasswordForm.password = ''
        this.changePasswordForm.confirmPassword = ''
      }
    },
    mounted() {
      this.getUser();
      if (this.$store.state.user.userType == UserTypes.WertheimAdministrator) {
        this.isAdmin = true
      }
    },
    computed: {
      ...mapGetters(["languages", "getCurrentUser"]),
      validated() {
        if (this.changePasswordForm.actualPassword && this.changePasswordForm.password && this.changePasswordForm
          .confirmPassword) {
          if (this.changePasswordForm.password == this.changePasswordForm.confirmPassword) {
            return true
          }
        }
        return false
      },
      canEdit: function(){
        if(this.$store.state.user.userId == this.userId){
          return true
        }
        else{
          return false
        }
      }
    },

  };
</script>
<style scoped>
  .v-text-field {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
</style>